import { LocaleSwitch } from './locale-switch/LocaleSwitch';
import { Spinner } from './Spinner';
import { ThemeSwitch } from './ThemeSwitch';

export const LoadingPage = () => {
  return (
    <div className="h-screen flex items-center justify-center relative">
      <Spinner />
      <div className="absolute top-4 right-4 flex flex-row items-center gap-2">
        <ThemeSwitch />
        <LocaleSwitch />
      </div>
    </div>
  );
};
